import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { history } from 'store';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import Typography from 'material-ui/Typography';

class PasswordLoginForm extends Component {
  static propTypes = {
    email: PropTypes.string,
    password: PropTypes.string,
    loginUser: PropTypes.func,
    sendMagicLink: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      email: this.props.email,
      password: "",
      error: ""
    }
  };

  handleFieldChange = e => this.setState({ [e.target.name]: e.target.value });

  handleLogin = (creds) => {
    if (this.state.password.length > 0) {
      this.props.loginUser({email: this.state.email, password: this.state.password}).then( resp => {
        if (resp) {
          this.setState({ error: "" });
          this.props.hideModal();
          // history.push('/profile');
        } else {
          this.setState({ error: "Your password or email was incorrect" });
        }
      });
    } else {
      this.setState({ error: "Please enter your password" });
    }
    
  }

  render() {
    return (
      <div>
        <div>
          <TextField 
            type="email"
            name="email"
            label="Email"
            margin="normal"
            value={this.state.email} 
            onChange={this.handleFieldChange}
            fullWidth 
          />
          <TextField
            autoFocus
            type="password"
            name="password"
            label="Password"
            margin="normal"
            value={this.state.password}
            onChange={this.handleFieldChange}
            fullWidth
          />
          { this.state.error !== "" ? <Typography color="secondary">{this.state.error}</Typography> : null }
          <Button
            variant="raised"
            color="primary"
            onClick={() => this.handleLogin({email: this.state.email, password: this.state.password})}
            style={{width: '100%'}}
          >Log In</Button>
        </div>
        <div style={{textAlign: 'center'}}>
          <Button
            color="primary"
            onClick={() => this.props.openModal("reset", 1, false)}
            style={{marginTop: '10px'}}
          >Forgot Password?</Button>
        </div>
        <hr />
        <div>
          <Button
            style={{width: '100%'}}
            onClick={() => this.props.sendMagicLink(this.state.email)}
          >Send me a login link</Button>
        </div>
      </div>
    )
  }
}

export default PasswordLoginForm;


// WEBPACK FOOTER //
// ./routes/Modal/Login/components/PasswordLoginForm/index.jsx